export default "__VITE_ASSET__DNfE$EqN__"